var text_field_default = {
  "root": "Iuapv",
  "text": "fuSoz",
  "input": "je09D",
  "small": "_7w6a3",
  "medium": "Q68w3",
  "large": "eCzYC",
  "webview": "KIAoE",
  "endAdornment": "PgM-N",
  "shown": "qZhgv",
  "value": "_1shil",
  "spinner": "v8Trd",
  "spin": "_73UYR"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
